import React, { useState } from "react";

import { Modal, Alert, DatePicker } from "antd";
import api from "../../../../services/api";

export const RelatorioHistoricoValorParcelas = ({ history }) => {
  const { RangePicker } = DatePicker;
  const [dates, setDates] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const handleOk = () => {
    if (!dates) {
      setError("Selecione as datas");
      return;
    }

    setError(null);
    setLoading(true);

    api
      .get("/contratos/reports/historico-valores/", {
        params: {
          dt_cadastro__gte: dates.initial.format("YYYY-MM-DD"),
          dt_cadastro__lte: dates.final.format("YYYY-MM-DD")
        }
      })
      .then(({ data }) => {
        if (!data.report) {
          Modal.error({
            content: "Falha ao obter a url do relatório gerado."
          });
          return;
        }

        const url = data.report;

        Modal.success({
          content: "Relatório gerado com sucesso!"
        });

        window.open(url);
      })
      .catch(err => {
        console.error(err);

        Modal.error({
          content: "Ocorreu um erro ao gerar relatório."
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => history.goBack();

  const handleDateChange = value => {
    setError(null);

    if (!value || value.length !== 2) {
      setDates(null);
      return;
    }

    const initalDate = value[0];
    const finalDate = value[1];

    if (initalDate.isAfter(finalDate)) {
      return;
    }

    setDates({
      initial: initalDate,
      final: finalDate
    });
  };

  return (
    <Modal
      title="Relatório de Histórico Valor Parcelas"
      visible
      onOk={handleOk}
      cancelText="Cancelar"
      onCancel={handleCancel}
      okText="Gerar"
      confirmLoading={isLoading}
    >
      <strong>Selecione as datas e clique em "Gerar"</strong>
      <br />
      <span>* Filtro por data de alteração dos valores.</span>

      <div
        style={{
          marginTop: "15px"
        }}
      >
        {error && (
          <div
            style={{
              margin: "8px 0px 8px 0px"
            }}
          >
            <Alert message={error} type="error" />
          </div>
        )}
        <RangePicker
          onChange={handleDateChange}
          format={"DD/MM/YYYY"}
          placeholder={["Data de início", "Data fim"]}
          value={dates ? [dates.initial, dates.final] : null}
          style={{
            width: "100%"
          }}
        />
      </div>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/Relatorios/HistoricoValorParcelas/index.jsx